<div
  id="legal-information-container"
  *ngIf="legalInformation$ | async as legalInformation"
  [innerHTML]="legalInformation"
></div>
